export default {

    name: 'services',

    computed:
    {
        current()
        {
            return this.$store.currentNum
        },

        links()
        {
            return [
                {
                    label: 'Assistance',
                    link: { name: 'assistant' }
                },
                {
                    label: 'Mining',
                    link: { name: 'mining' }
                },
                {
                    label: 'Automation',
                    link: { name: 'automation' }
                },
                {
                    label: 'Intelligence',
                    link: { name: 'ia' }
                }
            ]
        }
    }
}
